"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _PageNavigator = require("./PageNavigator");
Object.keys(_PageNavigator).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _PageNavigator[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PageNavigator[key];
        }
    });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _constants[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _constants[key];
        }
    });
});
var _getPageNumber = require("./getPageNumber");
Object.keys(_getPageNumber).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _getPageNumber[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _getPageNumber[key];
        }
    });
});
